/* eslint-disable */

export const getUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export const hashString = (str = '') => {
    return str.split("").reduce((a,b) => {
        a = ((a<<5) - a) + b.charCodeAt(0);
        return a&a
    },0);
}
